module.exports = __webpack_public_path__ + "static/img/honor08.2911901.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/honor08.jpg
// module id = lPrO
// module chunks = 0